module.exports = __webpack_public_path__ + "img/hero_scene.4f4a0067.png";